import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { CheckCircle, Music } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  artistCount: number;
}

export function SuccessModal({ isOpen, onClose, artistCount }: SuccessModalProps) {
  const { t } = useTranslation('collab-club');
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md text-center">
        <DialogHeader>
          <DialogTitle className="sr-only">Success</DialogTitle>
        </DialogHeader>

        <div className="space-y-6 py-4">
          <div className="flex justify-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="h-8 w-8 text-green-600" />
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">{t('requests_sent')}</h2>
            <p className="text-gray-600">
              {t('requests_sent_description', { count: artistCount })}
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-center gap-2 text-blue-800 mb-2">
              <Music className="h-4 w-4" />
              <span className="font-semibold">{t('what_happens_next')}</span>
            </div>
            <ul className="text-sm text-blue-700 space-y-1 text-left">
              <li>• {t('what_happens_next_1')}</li>
              <li>• {t('what_happens_next_2')}</li>
              <li>• {t('what_happens_next_3')}</li>
              <li>• {t('what_happens_next_4')}</li>
            </ul>
          </div>

          <Button onClick={onClose} className="w-full bg-blue-500 hover:bg-blue-600">
            {t('continue_discovering')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
